import React, { useEffect } from "react";
import { parseCodeFromQuery } from "../lib/google-oauth";

export const GoogleCallback = () => {
  useEffect(() => {
    const result = parseCodeFromQuery();

    if (result.error) {
      window.opener.postMessage(
        {
          type: "GOOGLE_AUTH_ERROR",
          error: result.errorDescription || result.error,
        },
        window.location.origin,
      );
    } else {
      window.opener.postMessage(
        {
          type: "GOOGLE_AUTH_SUCCESS",
          payload: {
            code: result.code,
          },
        },
        window.location.origin,
      );
    }
  }, []);

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4" />
        <p className="text-gray-600">Completing sign-in...</p>
      </div>
    </div>
  );
};

